module.exports = __webpack_public_path__ + "static/media/oval.05e0b84d.svg";